import ButtonIcon from "components/ButtonIcon/ButtonIcon.tsx";
import { getBaseUrl } from "services/utils.ts";

const HandbookButton = () => {
  const baseUrl = getBaseUrl();
  return (
    <ButtonIcon onClick={() => window.open(`${baseUrl}handbook/`, "_blank")}>
      library_books
    </ButtonIcon>
  );
};

export default HandbookButton;
